import { render, staticRenderFns } from "./AccessControlAuth.vue?vue&type=template&id=20101365&scoped=true"
import script from "./AccessControlAuth.vue?vue&type=script&lang=js"
export * from "./AccessControlAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20101365",
  null
  
)

export default component.exports